// "CSV indir" in /ekip (eksik listesi #18): the rows the team is looking at, for Excel in Turkish locale
// (semicolon separator, UTF-8 BOM). Cells that a spreadsheet would run as a formula are quoted as text.
// Days are counted in Türkiye time: a 01:30 application on 6 Kasım is not a 5 Kasım one (P2, 5 Kasım 2026 review).
const istanbulDay = at => { const d = new Date(at); return Number.isNaN(d.valueOf()) ? String(at).slice(0, 10) : d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Istanbul' }); };
const cell = value => {
  let s = value == null ? '' : String(value);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
export function leadsCsv(rows, { statusLabel = s => s, employeesLabel = e => e } = {}) {
  const head = ['Tarih', 'Marka', 'Kişi', 'E-posta', 'Öncelikli hedef', 'Eşleşme', 'Durum', 'Çalışan', 'Kaynak', 'Hesap'];
  const lines = rows.map(l => [l.submittedAt ? istanbulDay(l.submittedAt) : '', l.brandName, l.contactName, l.contactEmail, l.primary, l.matchCount ?? '',
    statusLabel(l.status), employeesLabel(l.employees), l.source === 'stand' ? 'Stant' : 'Onboarding', l.hasAccount ? 'Var' : 'Yok']);
  return '﻿' + [head, ...lines].map(r => r.map(cell).join(';')).join('\r\n') + '\r\n';
}
